import { Link, Box, Flex, Text } from "@chakra-ui/react";
import { BorderedTag } from "../../../components/tags/BorderedTag";
import { Article } from "../../../types";
import { DateTime } from "luxon";
import { useMobileBreakpoint } from "../../../utils/useBreakpoints";
import { Avatar } from "../../../components/user/Avatar";
import { useSlideInMenu } from "../../../components/slideInMenu/hooks/useSlideInMenu";
import { useAccountData } from "../../../hooks/useAccountData";
import { FunnelContextArea } from "../../../components/funnel/types";

export function NewsDetailsHeader({ article }: { article: Article }) {
  const { openUserProfile } = useSlideInMenu();
  const isMobile = useMobileBreakpoint();
  const accountData = useAccountData();
  const date = DateTime.fromSQL(article.published_time);
  const formattedDate = date.toFormat("MMMM d, yyyy");
  const isUserProfileEnabled = accountData?.features?.["user_profile"];

  const isVideoHub = article?.category?.slug === "video-hub";
  return (
    <Box>
      <Text
        as="h1"
        variant="newsTitle"
        mb={isVideoHub ? "8px" : "24px"}
        fontSize={isVideoHub ? "24px" : undefined}
        color="dune.dune"
      >
        {article.title}
      </Text>
      {!isVideoHub && article.category ? (
        <>
          <Link href={article.category.url}>
            <Text
              variant="newsHeader"
              fontSize={isMobile ? "14px" : "16px"}
              color="blaze.blaze"
              pb="16px"
            >
              {article.category.display_name}
            </Text>
          </Link>
        </>
      ) : null}
      <Flex direction="row" gap="11px" alignItems="center" mb="40px">
        {isVideoHub ? (
          <Avatar
            username={article.author.name}
            imageSrc={article.author.avatar_tiny_url}
            openProfileOnClick
            contextArea={FunnelContextArea.news}
          />
        ) : null}
        <Flex>
          {isVideoHub ? null : <Text variant="newsHeader">By:&nbsp;</Text>}
          <Link
            href={!isUserProfileEnabled ? article.author.url : undefined}
            onClick={
              isUserProfileEnabled
                ? () =>
                    openUserProfile(article.author.name, { area: FunnelContextArea.news })
                : undefined
            }
            display="flex"
            alignContent="center"
          >
            <Text
              variant="newsHeader"
              textDecoration={isVideoHub ? "none" : "underline"}
            >
              {article.author.name}
            </Text>
          </Link>
        </Flex>

        {article.author.is_admin ? <BorderedTag text="Admin" /> : null}

        <Text variant="newsHeader">|</Text>
        <Text variant="newsHeader">{formattedDate}</Text>

        {article.can_edit ? <EditButton article={article} /> : null}
      </Flex>
    </Box>
  );
}

function EditButton({ article }: { article: Article }) {
  return (
    <Link
      borderRadius="4px"
      padding="2px 8px 3px 8px"
      alignItems="center"
      bg="blaze.300"
      href={article.edit_url}
      height="fit-content"
      minWidth="fit-content"
      _hover={{ bg: "blaze.400", pointer: "cursor" }}
    >
      <Text variant="monospaceTime" color="black">
        Edit
      </Text>
    </Link>
  );
}
